import Cookie from 'js-cookie'
import at from 'lodash/at';

export function useLocaleCommon() {
  const { t, locale, locales, setLocale } = useI18n();
  const baseStore = useBaseStore()
  const yarnStore = useYarnStore()
  const router = useRouter()
  const localePath = useLocalePath()

  const handleChangeLang = async (lang, pageLang = null) => {
    const pLang = pageLang || locale.value
    if (lang === pLang) return
    baseStore.setSpinner()
    await setLocale(lang)
    baseStore.hideSpinner()
  }

  const localText = (lang) => {
    if (!lang) return ''
    const locale = locales.value.find((locale) => locale.code === lang)
    if (lang === locales.value[0].code) return 'English'
    return locale ? locale.name : ''
  }

  const setCustomLocale = (target) => {
    baseStore.$patch({ customLocale: target })
  }

  const changeCustomLocale = (newLocale) => {
    if (newLocale) {
      yarnStore.$patch({
        yarnDetail: null,
        yarnRefImages: null,
      })
      baseStore.$patch({
        customLocale: newLocale,
      })
    }
  }

  const getAllLocales = async () => {
    const results = await Promise.all(
      locales.value.map(locale => {
        return baseStore.getLanguagesByCode(locale.code)
      })
    )

    const data = results.reduce((previous, language, index) => {
      if (language !== true) {
        previous[locales.value[index].code] = language
      }
      return previous
    }, { en: null, zh: null, ja: null })

    baseStore.$patch({ localeLanguages: data })
    changeCustomLocale(locale.value)
  }

  const watchCustomLocale = (isWatchingCustomLocale) => {
    if (isWatchingCustomLocale) {
      getAllLocales()
    } else {
      setCustomLocale(locale.value)
    }
  }

  const getWordByCustomLocale = (code, messages) => {
    if (baseStore.customLocale === locale.value) {
      return at(messages[locale.value], code)[0]
    } else {
      return at(baseStore.localeLanguages[baseStore.customLocale], code)[0]
    }
  }

  const getWordByRootState = (code, messages) => {
    return at(messages[locale.value], code)[0]
  }

  return {
    handleChangeLang,
    localText,
    setCustomLocale,
    getWordByCustomLocale,
    changeCustomLocale,
    getAllLocales,
    watchCustomLocale,
    getWordByRootState
  }
}

export function useLangCommon() {
  const { t, locales } = useI18n()

  const languageOptions = computed(() => {
    const languageName = [
      t('common.10250'),
      t('common.10251'),
      t('common.10249')
    ]

    return locales.value.map((languageCode, index) => ({
      text: languageName[index],
      value: languageCode.code
    }))
  })
  return { languageOptions }
}
